<template>
  <div :class="$style.container">
    <div :class="$style.magneticStripe"></div>
    <div :class="$style.paperStrip">
      <span></span>
      <span></span>
      <span></span>
      <div
        :class="$style.code"
        v-text="displayCode"
      />
    </div>
    <div :class="$style.logo">
      <!-- TODO: @danealton переработать на динамическое определение платежной системы или банка -->
      <img src="@/assets/images/payment-system-card/yandex-pay.svg" alt="" />
    </div>
  </div>
</template>

<script>
const CODE_PLACEHOLDER = 'X';

export default {
  name: 'PaymentCardSecretCodeSide',
  props: {
    code: String,
  },
  created() {
    // TODO: @danealton раскомментировать после подключения днамического определения плтежной системы или банка
    // document.documentElement.style.setProperty('--cover-world-map', '#fff');
  },
  computed: {
    displayCode() {
      const codeLength = this.code.length;

      return CODE_PLACEHOLDER.repeat(codeLength);
    },
  },
};
</script>

<style lang="css">
  :root {
    --cover-world-map: #628E34;
  }
</style>

<style lang="sass" module>
  .container
    position: relative
    width: 100%
    min-height: 160px
    overflow: hidden
    background-color: #7CB342
    box-shadow: 0px 1px 2px rgba(189, 189, 189, 0.5)
    border-radius: 5px
    z-index: 1000

    +respond-to('medium')
      min-height: 190px

    &:after
      content: ''
      width: 100%
      height: 100%
      position: absolute
      top: 0
      left: 0
      mask-image: url('@/assets/svg/cover/world-map.svg')
      mask-position: top 25px center
      background-color: var(--cover-world-map)
      z-index: -1

  .magneticStripe
    height: 40px
    margin: 12px 0 10px
    background-color: rgba(0, 0, 0, 0.25)

    +respond-to('medium')
      height: 50px
      margin: 15px 0

  .paperStrip
    position: relative
    height: 36px
    margin: 0 50px 0 15px
    background-color: #fff

    +respond-to('medium')
      height: 40px
      margin: 0 58px 0 18px

    span
      +size(100%, 5px)
      position: absolute
      background-color: rgba(69, 90, 100, 0.15)
      opacity: .5

      &:nth-child(1)
        top: 6px

      &:nth-child(2)
        top: 50%
        transform: translateY(-50%)

      &:nth-child(3)
        bottom: 6px

  .logo
    display: flex
    margin: 20px 12px 12px
    justify-content: flex-end

    +respond-to('medium')
      margin: 25px 15px 15px

  .code
    +font-type('medium', 18, 26)
    +flexbox
    +justify-content(flex-end)
    +align-items(center)
    height: 100%
    margin: 5px 10px
    color: rgba(0, 0, 0, 0.25)
</style>
